import { AcademicCapIcon, BookOpenIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { ComponentType, SVGProps } from 'react';

export type OfferingType =
  | 'aep'
  | 'epc'
  | 'coaching'
  | 'group-coaching'
  | 'msuite'
  | 'program-sequence';

type HeroIcon = ComponentType<SVGProps<SVGSVGElement>>;

/**
 * Get the appropriate icon component for a program's offering type
 */
export const getOfferingTypeIcon = (offeringType: OfferingType | string): HeroIcon => {
  switch (offeringType) {
    case 'aep':
    case 'msuite':
      return BookOpenIcon; // On-Demand
    case 'epc':
      return AcademicCapIcon; // Professor-Led
    case 'coaching':
    case 'group-coaching':
      return UserGroupIcon; // Leadership Coaching
    default:
      return BookOpenIcon;
  }
};

/**
 * Get the display label for a program's offering type category
 */
export const getOfferingTypeLabel = (offeringType: OfferingType | string): string => {
  switch (offeringType) {
    case 'aep':
    case 'msuite':
      return 'On-Demand';
    case 'epc':
      return 'Professor-Led';
    case 'coaching':
    case 'group-coaching':
      return 'Leadership Coaching';
    default:
      return 'Course';
  }
};

/**
 * Check if a program is unlicensed (no license type IDs)
 */
export const isUnlicensed = (productLicenseTypeIds: number[]): boolean => {
  return productLicenseTypeIds.length === 0;
};

/**
 * Get the count of scheduled dates for a program
 */
export const getScheduledDateCount = (scheduled: unknown[]): number => {
  return scheduled?.length ?? 0;
};
